// extracted by mini-css-extract-plugin
export default {"textarea":"RecipeDescriptField_textarea__gEIKL","preparationTitle":"RecipeDescriptField_preparationTitle__A0uPE"};